import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { Seo } from "@/components/Seo";

export default function Events() {
  const { data: events = [] } = useQuery({ queryKey: ["events"], queryFn: async () => (await api.get("/events")).data });

  return (
    <div className="mx-auto max-w-[1600px] px-5 py-12 md:px-8" data-testid="events-page">
      <Seo title="Events — The Hoodie Project®" description="Community drops, paint parties and partner events." />
      <div className="mb-10 border-b border-border pb-6">
        <p className="text-xs tracking-[0.3em] text-muted-foreground">COMMUNITY</p>
        <h1 className="mt-3 font-display text-5xl font-extrabold tracking-tighter md:text-7xl">EVENTS</h1>
      </div>

      {events.length === 0 ? (
        <p className="text-muted-foreground" data-testid="events-empty">No events yet. Stay tuned.</p>
      ) : (
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {events.map((e) => (
            <Link key={e.id} to={`/events/${e.slug}`} data-testid={`event-card-${e.slug}`}
              className="group relative block overflow-hidden border border-border">
              <img src={e.image} alt={e.title} className="h-80 w-full object-cover opacity-70 transition-all duration-500 group-hover:scale-105 group-hover:opacity-90" />
              <div className="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-black to-transparent p-8">
                {e.partner && <span className="mb-2 w-fit bg-white px-2 py-1 text-[10px] font-bold tracking-widest text-black">{e.partner.toUpperCase()}</span>}
                <h3 className="font-display text-3xl font-extrabold tracking-tighter">{e.title}</h3>
                <p className="mt-1 text-xs text-muted-foreground">{e.date} · {e.location}</p>
                <span className="mt-4 flex items-center gap-2 text-xs tracking-[0.2em]">VIEW EVENT <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
